// import { WSIBClassList } from "components/WSIBClass";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { WSIBMaximumEarningsList } from "../../components/WSIBMaximumEarningsList";

export interface IWSIBMaximumEarningsList { }

export const WSIBMaximumEarningsListPage: FC<IWSIBMaximumEarningsList> = (
  props: IWSIBMaximumEarningsList
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Maximum Earnings List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<WSIBMaximumEarningsList />}
    />
  );
};
